import { FeatureNameType } from 'common/open-features'

export const shouldRenderMenuItem = (
  featureFlags: Partial<Record<FeatureNameType, boolean>>,
  featureFlagKey?: string
): boolean => {
  return featureFlagKey ? !!featureFlags[featureFlagKey as FeatureNameType] : true
}
